import Alpine from "alpinejs";

Alpine.data("workOrdersForm", (startTimeParam, startDateParam, durationParam) => ({
  // Time picker
  hours: HOURS,
  minutes: MINUTES,
  selectedStartHour: HOURS[10],
  selectedStartMinute: MINUTES[0],
  selectedStartTime: `${HOURS[10]}:${MINUTES[0]}`,
  timePickerVisible: false,
  // Duration picker
  durationHours: DURATION_HOURS,
  durationMinutes: DURATION_MINUTES,
  selectedDurationHour: DURATION_HOURS[0],
  selectedDurationMinute: DURATION_MINUTES[1],
  selectedDuration: `${DURATION_HOURS[0]}:${DURATION_MINUTES[1]}`,
  durationPickerVisible: false,
  // Form
  startDate: "",
  startDateTime: "",
  endDateTime: "",
  init() {
    // Initialize data when editing
    this.initializeFromParams();

    // Time picker
    this.$watch("selectedStartHour, selectedStartMinute", () => {
      this.selectedStartTime = `${this.selectedStartHour}:${this.selectedStartMinute}`;
      this.scrollToSelectedTime();
    });

    // Duration picker
    this.$watch("selectedDurationHour, selectedDurationMinute", () => {
      this.selectedDuration = `${this.selectedDurationHour}:${this.selectedDurationMinute}`;
    });

    // Scroll to selected when opening
    this.$watch("timePickerVisible", visible => {
      if (visible) {
        setTimeout(() => {
          this.scrollToSelectedTime();
        }, 300);
      }
    });

    // Set startDateTime
    this.$watch("startDate, selectedStartTime", value => {
      this.startDateTime = `${value}T${this.selectedStartTime}`;
    });

    // Calculate end date and time based on start date and duration
    this.$watch("startDateTime, selectedDuration", () => {
      const { startDate, selectedDuration } = this;
      if (!startDate || !selectedDuration.length) {
        return;
      }
      this.endDateTime = addDurationToDateTime(this.startDateTime, this.selectedDuration);
    });
  },
  initializeFromParams() {
    if (!startTimeParam || !startDateParam || !durationParam) return;
    this.selectedStartHour = startTimeParam.split(":")[0];
    this.selectedStartMinute = startTimeParam.split(":")[1];
    this.selectedStartTime = startTimeParam;
    this.startDate = startDateParam.split(" ")[0];
    this.startDateTime = `${startDateParam}T${startTimeParam}`;
    const formattedDuration = minutesToTime(durationParam);
    this.endDateTime = addDurationToDateTime(this.startDateTime, formattedDuration);
    this.selectedDurationHour = formattedDuration.split(":")[0];
    this.selectedDurationMinute = formattedDuration.split(":")[1];
    this.selectedDuration = formattedDuration;
  },
  showTimePicker() {
    this.timePickerVisible = true;
  },
  scrollToSelectedTime() {
    const hourElement = document.getElementById(`hour-${this.selectedStartHour}`);
    const minuteElement = document.getElementById(`minute-${this.selectedStartMinute}`);

    if (hourElement) {
      hourElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    }

    if (minuteElement) {
      // Small delay to ensure hour scroll completes first
      setTimeout(() => {
        minuteElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }, 100);
    }
  }
}));

function addDurationToDateTime(startDateTimeStr, durationStr) {
  const startDate = new Date(startDateTimeStr);

  const [hours, minutes] = durationStr.split(":").map(Number);
  startDate.setHours(startDate.getHours() + hours);
  startDate.setMinutes(startDate.getMinutes() + minutes);

  // Format back to "YYYY-MM-DDTHH:MM"
  const year = startDate.getFullYear();
  const month = String(startDate.getMonth() + 1).padStart(2, "0");
  const day = String(startDate.getDate()).padStart(2, "0");
  const hoursStr = String(startDate.getHours()).padStart(2, "0");
  const minutesStr = String(startDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hoursStr}:${minutesStr}`;
}

function minutesToTime(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(remainingMinutes).padStart(2, "0")}`;
}

const DURATION_MINUTES = ["00", "30"];
const DURATION_HOURS = ["00", "01", "02", "03"];

const MINUTES = ["00", "15", "30", "45"];
const HOURS = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23"
];
